import { useRef, useState } from 'react';
import type { DigitalMenuOptionGroup, DigitalMenuProductDetail } from 'shared-models';
import { changePick, configuredDish, defaultPicks, pickCounts, validChoices, type DigitalMenuBasketLine } from './digital-menu.utils';

export function useDishConfiguration(product: DigitalMenuProductDetail, onAdd: (line: DigitalMenuBasketLine) => void) {
  const [picks, setPicks] = useState(() => defaultPicks(product.groups));
  const [quantity, setQuantity] = useState(1);
  const added = useRef(false);
  const counts = pickCounts(picks);
  const line = configuredDish(product, picks, quantity);
  const valid = product.available && validChoices(product.groups, counts);
  const pick = (group: DigitalMenuOptionGroup, id: number, delta: 1 | -1) => setPicks((previous) => changePick(group, id, previous, delta));
  const add = () => {
    if (!valid || added.current) return;
    added.current = true;
    try { onAdd(line); } catch (error) { added.current = false; throw error; }
  };
  return { picks, counts, quantity, setQuantity, line, valid, pick, add };
}